
export function getForecastsDescription(section, key) {
    const dailyFields = {
        "daily.dt": "Time of the forecasted data, Unix, UTC.",
        "daily.sunrise": "Sunrise time, Unix, UTC. Not returned for polar areas during midnight sun or polar night periods.",
        "daily.sunset": "Sunset time, Unix, UTC. Not returned for polar areas during midnight sun or polar night periods.",
        "daily.moonrise": "The time of when the moon rises for this day, Unix, UTC.",
        "daily.moonset": "The time of when the moon sets for this day, Unix, UTC.",
        "daily.moon_phase": "Moon phase. 0 and 1 are 'new moon', 0.25 is 'first quarter moon', 0.5 is 'full moon', and 0.75 is 'last quarter moon'.",
        "daily.summary": "A brief textual summary of the weather conditions for the day.",
        "daily.temp.day": "Daytime temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.temp.min": "Minimum daily temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.temp.max": "Maximum daily temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.temp.night": "Nighttime temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.temp.eve": "Evening temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.temp.morn": "Morning temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.feels_like.day": "Daytime temperature accounting for the human perception of weather. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.feels_like.night": "Nighttime temperature accounting for the human perception of weather. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.feels_like.eve": "Evening temperature accounting for the human perception of weather. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.feels_like.morn": "Morning temperature accounting for the human perception of weather. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.pressure": "Atmospheric pressure on the sea level, hPa.",
        "daily.humidity": "Humidity, %.",
        "daily.dew_point": "Dew point temperature. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "daily.wind_speed": "Wind speed. Units – default: metre/sec, metric: metre/sec, imperial: miles/hour.",
        "daily.wind_gust": "Wind gust speed. Units – default: metre/sec, metric: metre/sec, imperial: miles/hour.",
        "daily.wind_deg": "Wind direction, degrees (meteorological).",
        "daily.clouds": "Cloudiness, %.",
        "daily.pop": "Probability of precipitation. Values range from 0 to 1, where 0 is 0% and 1 is 100%.",
        "daily.rain": "Precipitation volume, mm.",
        "daily.snow": "Snow volume, mm.",
        "daily.uvi": "The maximum value of the UV index for the day.",
        "daily.weather.id": "Weather condition ID.",
        "daily.weather.main": "Group of weather parameters (e.g., Rain, Snow).",
        "daily.weather.description": "Weather condition within the group.",
        "daily.weather.icon": "Weather icon ID."
      };

      const currentFields = {
        "lat": "Latitude of the location, decimal (-90; 90).",
        "lon": "Longitude of the location, decimal (-180; 180).",
        "timezone": "Timezone name for the requested location.",
        "timezone_offset": "Shift in seconds from UTC.",
        "current.dt": "Current time, Unix, UTC.",
        "current.sunrise": "Sunrise time, Unix, UTC. For polar areas in midnight sun and polar night periods, this parameter is not returned in the response.",
        "current.sunset": "Sunset time, Unix, UTC. For polar areas in midnight sun and polar night periods, this parameter is not returned in the response.",
        "current.temp": "Temperature. Units - default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "current.feels_like": "Temperature accounting for the human perception of weather. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "current.pressure": "Atmospheric pressure on the sea level, hPa.",
        "current.humidity": "Humidity, %.",
        "current.dew_point": "Atmospheric temperature below which water droplets begin to condense and dew can form. Units – default: kelvin, metric: Celsius, imperial: Fahrenheit.",
        "current.clouds": "Cloudiness, %.",
        "current.uvi": "Current UV index.",
        "current.visibility": "Average visibility, metres. The maximum value of the visibility is 10 km.",
        "current.wind_speed": "Wind speed. Units – default: metre/sec, metric: metre/sec, imperial: miles/hour.",
        "current.wind_gust": "Wind gust (where available). Units – default: metre/sec, metric: metre/sec, imperial: miles/hour.",
        "current.wind_deg": "Wind direction, degrees (meteorological).",
        "current.rain.1h": "Rain volume for the last 1 hour, mm (where available).",
        "current.snow.1h": "Snow volume for the last 1 hour, mm (where available).",
        "current.weather.id": "Weather condition id.",
        "current.weather.main": "Group of weather parameters (Rain, Snow, etc.).",
        "current.weather.description": "Weather condition within the group.",
        "current.weather.icon": "Weather icon id."
      };
      

      
      if (section === 'general') {
        const result = dailyFields['daily.' + key];
        return result ?? ''
      }
      if (section === 'temperature') {
        const result = dailyFields['daily.temp.' + key];
        return result ?? ''
      }
      if (section === 'feelsLike') {
        const result = dailyFields['daily.feels_like.' + key];
        return result ?? ''
      }
      if (section === 'weather') {
        const result = dailyFields['daily.weather.' + key];
        return result ?? ''
      }

}
